import Table from "../components/TableTemplate";
import { useLanguage } from "../config/LanguageContext";
import FooterCertificates from "../components/FooterCertificates";
import ResourceHeaderSection from "../sections/ResourceHeaderSection";
import ResourceContentListSection from "../sections/ResourceContentListSection";

function CarbonReduction2026() {
  const { currentLanguage, translations } = useLanguage();
  const t = translations.carbon26;

  return (
    <>
      <div className="resources-container">
        <ResourceHeaderSection
          t={t}
          currentLanguage={currentLanguage}
          isCarbonPage={true}
          pdfYear="2026-2027"
        />
        <div className="resources-content-container">
          <div className="resources-contents-wrapper">
            <ResourceContentListSection
              t={t}
              currentLanguage={currentLanguage}
            />
            <div className="resources-body-container">
              <h2 className="secondary" id="commitment">
                {t.commitment.header}
              </h2>
              <p>{t.commitment.text}</p>
              <h2 className="secondary" id="footprint">
                {t.baseline.header}
              </h2>
              <p>{t.baseline.text}</p>
              <h2 className="secondary" id="reporting">
                {t.currentEmissionsHeader}
              </h2>
              <Table data={t.emissionsTableData} />
              <h2 className="secondary" id="method">
                {t.methods.header}
              </h2>
              {t.methods.text.map((text, index) => (
                <p key={index}>{text}</p>
              ))}
              <ul className="resources-list">
                {t.methods.list.map((list, index) => (
                  <li key={index}>{list}</li>
                ))}
              </ul>
              {t.methods.followingText.map((text, index) => (
                <p key={index}>{text}</p>
              ))}
              <h2 className="secondary" id="projects">
                {t.reductionProjects.header}
              </h2>
              <p>{t.reductionProjects.text}</p>
              {t.reductionProjects.subheadings.map((heading, index) => (
                <div className="resources-text-wrapper" key={index}>
                  <h3 className="secondary">{heading}</h3>
                  <p>{t.reductionProjects.subText[index]}</p>
                </div>
              ))}
              <h3 className="secondary">{t.training.header}</h3>
              {t.training.text.map((text, index) => (
                <p key={index}>{text}</p>
              ))}
              <h3 className="secondary">{t.office.header}</h3>
              {t.office.text.map((text, index) => (
                <p key={index}>{text}</p>
              ))}
              <h2 className="secondary">{t.signOff.header}</h2>
              {t.signOff.text.map((text, index) => (
                <p key={index}>{text}</p>
              ))}
            </div>
          </div>
        </div>
      </div>
      <FooterCertificates />
    </>
  );
}

export default CarbonReduction2026;
